// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    heading: 'Work',
    link: '/Work',
    intro: 'Work-Life Challenges',
    content:
      'Parenting has never been harder. According to a Pew survey, fifty-nine percent of full-time working mothers say they don’t have enough leisure time. It’s even harder to balance work and parenting for single working moms. A single mom is supposed to take care of the kids and provide for them all by herself. To be able to provide for the children she often has no choice but to put in extra working hours. Therefore, balancing the professional responsibilities and parenting is a major problem faced by single mothers.',
    suggestions:
      'Ask for helpFind flexible working hours.Work from home (explore ways to make money as a SAHM).Set boundaries and goals',
    img: 'https://res.cloudinary.com/dfftvyqha/image/upload/v1632464518/3327597-removebg-preview_otj73f.png',
  },
  {
    id: 2,
    heading: 'Responsibility',
    link: 'Responsibility',
    intro: 'Guilt, Blame, and Responsibility',
    content:
      'Most single mothers are utterly sick of the motherhood and guilt rhetoric —especially working single mothers. They often feel like they’re forever coming up short when it comes to doing enough for their kids. Not to mention their boss and extended family, and yes, of course, their community. As single mothers, they have to do all of these things alone, and it’s not always easy.',
    suggestions:
      'Accept that parenting isn’t a competition and there is no right or wrong way to parenTLimit your social media usage.Learn to live in the moment.Spend quality time with your kidsTake time for yourself.Connect with like-minded moms.',
    img: 'https://res.cloudinary.com/dfftvyqha/image/upload/v1632465192/10770-removebg-preview_ttlkwy.png',
  },
  {
    id: 3,
    heading: 'Emotions',
    link: 'Emotions',
    intro: ' Emotional Challenges ',
    content:
      'Most single mothers are utterly sick of the motherhood and guilt rhetoric —especially working single mothers. They often feel like they’re forever coming up short when it comes to doing enough for their kids. Not to mention their boss and extended family, and yes, of course, their community. As single mothers, they have to do all of these things alone, and it’s not always easy.',
    suggestions:
      'Accept that parenting isn’t a competition and there is no right or wrong way to parenTLimit your social media usage.Learn to live in the moment.Spend quality time with your kidsTake time for yourself.Connect with like-minded moms.',
    img: 'https://res.cloudinary.com/dfftvyqha/image/upload/v1632465012/5870-removebg-preview_fvszwn.png',
  },
  {
    id: 4,
    heading: 'Financials',
    link: 'Financials',
    intro: ' Financial Strain ',
    content:
      'Most single mothers are utterly sick of the motherhood and guilt rhetoric —especially working single mothers. They often feel like they’re forever coming up short when it comes to doing enough for their kids. Not to mention their boss and extended family, and yes, of course, their community. As single mothers, they have to do all of these things alone, and it’s not always easy.',
    suggestions:
      'Accept that parenting isn’t a competition and there is no right or wrong way to parenTLimit your social media usage.Learn to live in the moment.Spend quality time with your kidsTake time for yourself.Connect with like-minded moms.',
    img: 'https://res.cloudinary.com/dfftvyqha/image/upload/v1641731979/515319-PIRK7R-406_opubhu.jpg',
  },
  {
    id: 5,
    heading: 'Time Management',
    link: 'Time ',
    intro: ' Limited Time and Fatigue ',
    content:
      'Most single mothers are utterly sick of the motherhood and guilt rhetoric —especially working single mothers. They often feel like they’re forever coming up short when it comes to doing enough for their kids. Not to mention their boss and extended family, and yes, of course, their community. As single mothers, they have to do all of these things alone, and it’s not always easy.',
    suggestions:
      'Accept that parenting isn’t a competition and there is no right or wrong way to parenTLimit your social media usage.Learn to live in the moment.Spend quality time with your kidsTake time for yourself.Connect with like-minded moms.',
    img: 'https://res.cloudinary.com/dfftvyqha/image/upload/v1641732130/3235815_whgny5.jpg',
  },
];
